import React from "react";
import { styled } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import TextField from "@mui/material/TextField";
import enLocale from "date-fns/locale/en-US";
import trLocale from "date-fns/locale/tr";
import i18next from "i18next";
import { FormHelperText } from "@mui/material";
import { useField } from "formik";
import { changeLabelForDateTimePicker } from "../../utils";

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#0063cc",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#0063cc",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#e5e5e5",
    },
    "&:hover fieldset": {
      borderColor: "#0063cc",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#0063cc",
    },
  },
});

interface LocaleMap {
  [key: string]: string | Locale;
}

const localeMap: LocaleMap = {
  en: enLocale,
  tr: trLocale,
};

interface MaskMap {
  [key: string]: string;
}

const maskMap: MaskMap = {
  tr: "__.__.____",
  en: "__/__/____",
};

interface DateTimeInputProps {
  name: string;
  label: string;
  values?: any;
  setFieldValue: Function;
  disabled?: boolean;
  minDateTime?: any;
  customValue?: string;
}

const DateTimeInput = ({
  name,
  label,
  setFieldValue,
  disabled,
  minDateTime,
  customValue,
}: DateTimeInputProps) => {
  const locale = i18next.language;
  const [field, meta] = useField(name);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      locale={localeMap[locale]}
    >
      <DateTimePicker
        minDateTime={minDateTime}
        mask={maskMap[locale]}
        label={label}
        value={changeLabelForDateTimePicker(field.value)}
        onChange={(newValue) => {
          setFieldValue(field.name, newValue);
        }}
        renderInput={(params) => (
          <CssTextField {...params} error={Boolean(meta.error)} fullWidth />
        )}
        clearable={true}
        disabled={disabled}
      />
      <FormHelperText style={{ marginLeft: "10px", color: "#d32f2f" }}>
        {Boolean(meta.error) ? meta.error : ""}
      </FormHelperText>
    </LocalizationProvider>
  );
};

export default DateTimeInput;
